import React, { useState, useEffect } from 'react';
import './ElConsumptionReadOnlyValue.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine } from '@fortawesome/free-solid-svg-icons';

const ElConsumptionReadOnlyValue = ({ header, measurement, addMeasurementToGraph, inputValue }) => {
  const [value, setValue] = useState(inputValue);
  const [isGraphSelected, setIsGraphSelected] = useState(false);

  useEffect(() => {
    setValue(inputValue);
  }, [inputValue]);

  const handleAddMeasurementToGraph = () => {
    setIsGraphSelected(!isGraphSelected);
    addMeasurementToGraph(header, measurement, false, 'electricity');
  };

  return (
    <div className="elconsumption-input-container">
      <span className="elconsumption-readonlyevalue-header">{header}</span>
      <input type="text" value={value ? Math.round(value) : ''} readOnly className='elconsumption-input-field' />

      {measurement && (
        <button onClick={handleAddMeasurementToGraph} className={isGraphSelected ? 'graph-btn-selected' : 'graph-btn'}>
          <FontAwesomeIcon icon={faChartLine} />
        </button>
      )}
    </div>
  );
};

export default ElConsumptionReadOnlyValue;
